import { CloseRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { useAppDispatch } from '../../redux-store/hooks';
import { closeSnackbar } from '../../redux-store/notifications/notificationsSlice';

export interface IProps {
  snackbarId: number;
}

export default function EnqueueSnackbarAction(props: IProps) {
  const { snackbarId } = props;

  const dispatch = useAppDispatch();
  return (
    <IconButton
      onClick={() => {
        dispatch(closeSnackbar(snackbarId));
      }}>
      <CloseRounded style={{ color: 'white' }} />
    </IconButton>
  );
}
